export default __webpack_public_path__ + "static/media/signing-document.02de3e34.jpg";